var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBobLogoDesktop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 48,
    viewBox: "0 0 94 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 11.9963V48.0001H36V27.0014H33V44.9998H3.04114V14.997H21V11.9967L0 11.9963Z",
    fill: "#582483"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 24.0007H36V11.9966H24V24.0007ZM27 20.9971H33V14.9965H27V20.9971Z",
    fill: "#582483"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 0V8.99252H27V3.00562H45V20.995H39V24.0023H48V0H24Z",
    fill: "#582483"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.7589 40.119V44.3257H51.3654C52.6178 44.3257 53.2572 43.2183 53.2572 42.1838C53.2572 41.2027 52.6178 40.119 51.2877 40.119H47.7589ZM50.6987 37.0694C51.6721 37.0694 52.3358 36.3149 52.3358 35.2822C52.3358 34.1967 51.7744 33.4663 50.6744 33.4663H47.7589V37.0694H50.6987ZM53.8722 38.3048C56.1987 38.8849 57.1947 40.849 57.1947 42.2608C57.1947 45.1331 55.0726 47.5767 51.5698 47.5767H44V30.217H51.0574C54.2289 30.217 56.2747 32.0809 56.2747 35.0555C56.2747 36.1886 55.6877 37.6241 53.8722 38.3048Z",
    fill: "#582483"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.2175 44.16C71.1327 44.16 73.4352 41.8168 73.4352 38.9205C73.4352 36.0229 71.1327 33.6537 68.2175 33.6537C65.302 33.6537 63.0259 36.0229 63.0259 38.9205C63.0259 41.8168 65.302 44.16 68.2175 44.16ZM68.2175 30C73.2305 30 77.1697 33.9817 77.1697 38.9205C77.1697 43.8083 73.2305 47.814 68.2175 47.814C63.2319 47.814 59.291 43.8083 59.291 38.9205C59.291 33.9817 63.2319 30 68.2175 30Z",
    fill: "#582483"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.044 40.104V44.311H87.6506C88.9033 44.311 89.5423 43.2032 89.5423 42.1692C89.5423 41.1877 88.9033 40.104 87.5725 40.104H84.044ZM86.9838 37.0543C87.9556 37.0543 88.6209 36.2999 88.6209 35.2672C88.6209 34.1821 88.0613 33.4517 86.9595 33.4517H84.044V37.0543H86.9838ZM90.1574 38.2901C92.4835 38.8702 93.4799 40.8344 93.4799 42.2458C93.4799 45.1181 91.3594 47.562 87.8549 47.562H80.2852V30.202H87.3425C90.514 30.202 92.5598 32.0659 92.5598 35.0405C92.5598 36.1736 91.9728 37.6091 90.1574 38.2901Z",
    fill: "#582483"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBobLogoDesktop);
export default __webpack_public_path__ + "static/media/bob_logo_desktop.7f9235c20e3932bf09930306ccca5e6e.svg";
export { ForwardRef as ReactComponent };